<template>
  <ym-item class="pay-center-count-component"
           title="购买数量"
  >
    <div v-if="stock > 0"
         class="pay-center-count-stock"
    >
      {{ stockText }}
    </div>
    <div v-if="hideQuotaText !== true"
         class="pay-center-count-quota-text"
         v-html="quotaText"
    ></div>
    <ym-stepper class="pay-center-count-stepper"
                v-model="count"
                :min="min"
                :max="max"
                :disabled-input="disabledInput"
                integer
                @change="handleChange"
                @over-limit="handleOverLimit"
    />
  </ym-item>
</template>

<script>
  import { Stepper } from '@ymba/ym-ui';
  import PayCenterItem from '@/pages/Pay/components/PayCenterItem';
  import { MAX_QUOTA } from '@/utils/constant';
  import { calculatePrice } from '@/services/order';
  import validator from '@/utils/validator';

  export default {
    name: 'PayCenterCount',
    components: {
      'ym-item': PayCenterItem,
      'ym-stepper': Stepper,
    },
    props: {
      value: {
        type: [Number, String],
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      couponIds: {
        type: [Number, String],
        required: true,
      },
      discountIds: {
        type: [Number, String],
        required: true,
      },
      amount: {
        type: [Number, String],
        required: true,
      },
      delivery: {
        type: [Number, String],
        required: true,
      },
      unit: {
        type: String,
        default: '件',
      },
      hideQuotaText: {
        type: Boolean,
        default: false,
      },
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: MAX_QUOTA,
      },
      stock: {
        type: Number,
        default: 0,
      },
      disabledInput: {
        type: Boolean,
        default: false,
      },
      addressId: {
        type: [Number, String],
        required: true,
      },
      balancePay: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
    },
    data() {
      return {
        count: 1,
      };
    },
    computed: {
      quotaText() {
        const { min, max, unit } = this;
        const res = [];
        if (min > 1) {
          res.push(`${min}${unit}起售`);
        }
        if (max > 0) {
          res.push(`限购${max}${unit}`);
        }
        if (res.length === 0) return '';
        return `${res.join('，')}`;
      },
      stockText() {
        const {
          stock, unit, hideQuotaText, quotaText,
        } = this;
        let res = `库存${stock}${unit}`;
        if (hideQuotaText !== true && quotaText !== '') {
          res += '，';
        }
        return res;
      },
    },
    watch: {
      value(val) {
        this.count = val;
      },
      count(val) {
        this.$emit('input', val);
      },
    },
    methods: {
      async handleChange(num) {
        const {
          targetType,
          targetId,
          couponIds,
          discountIds,
          addressId,
        } = this;
        try {
          const data = await calculatePrice({
            targetType,
            targetId,
            targetCount: num,
            couponIds,
            discountIds,
            addressId,
          });
          this.$emit('update:amount', data.shouldPay);
          this.$emit('update:delivery', data.delivery);
          this.$emit('calculated', data.save);
          this.$emit('update:balancePay', data.balancePay);
        } catch (e) {
          this.$emit('error');
        }
      },
      handleOverLimit(type) {
        let message = '不能再减少了';
        if (type === 'plus') {
          message = '不能再增多了';
        }
        this.$toast(message);
      },
    },
    created() {
      this.count = this.value;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-count {
    &-stock {
      font-size: @font-size-small;
    }

    &-quota-text {
      font-size: @font-size-small;
    }

    &-stepper {
      margin-left: @size-extra-small;
      /deep/ .ym-stepper-input {
        -webkit-text-fill-color: @color-text-base;
        color: @color-text-base;
        opacity: 1;
      }
    }
  }
</style>
